import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-069d1472"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "categorie-card" }
const _hoisted_2 = ["src"]

import chrono from '@/assets/svg/illustration-chrono.svg'
import puzzle from '@/assets/svg/illustration-puzzle.svg'
import clapperboard from '@/assets/svg/illustration-clapperboard.svg'


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    iconName: null,
    btnText: null,
    link: null,
    shrinkButton: { type: Boolean }
  },
  emits: ['onGoTo'],
  setup(__props: any, { emit }) {

const props = __props as {
  title: string
  iconName: string
  btnText: string
  link: string
  shrinkButton: boolean
}





function getLoginPageIcon(): string {
  switch (props.iconName) {
    case 'chrono':
      return chrono
    case 'puzzle':
      return puzzle
    case 'clapperboard':
      return clapperboard
    default:
      return ''
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(props.title), 1),
    _createElementVNode("img", {
      src: getLoginPageIcon()
    }, null, 8, _hoisted_2),
    _createVNode(_component_router_link, {
      to: __props.link,
      class: _normalizeClass(["btn btn-md btn-primary", {
        'shrink-button': __props.shrinkButton,
      }]),
      innerHTML: props.btnText,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onGoTo')))
    }, null, 8, ["to", "class", "innerHTML"])
  ]))
}
}

})